// data/templatesData.js
const templates = [
  {
    title: "Restaurant Website",
    slug: "restaurant-website",
    component: "RestaurantTemplate",
    description: "Perfect for cafes and restaurants.",
    category: "Restaurant",
    price: "$299",
  },
  {
    title: "Tech Startup",
    slug: "tech-startup",
    component: "TechStartupTemplate",
    description: "Modern look for tech companies.",
    category: "Tech Startup",
    price: "$399",
  },
  {
    title: "Artist Portfolio",
    slug: "artist-portfolio",
    component: "ArtistPortfolioTemplate",
    description: "Creative portfolio for artists and designers.",
    category: "Artist Portfolio",
    price: "$199",
  },
];

export default templates;
